import { queryOptions } from '@tanstack/react-query';

import { queryKeys } from '@constants/queryKeys.constant';
import { EStaleTime } from '@enums/staleTime.enum';

import { voiceService } from './service';

export function testCallOptionsQueryOptions() {
  return queryOptions({
    queryFn: () => voiceService.getTestCallOptions(),
    queryKey: queryKeys.calls.testOptions(),
    staleTime: EStaleTime.OneHour,
  });
}
